// Shared formatting helpers for table displays.

// Parse a timestamp into a Date, returning null if invalid. Handles the
// API's "YYYY-MM-DD HH:MM:SS" format, which is NOT a spec-compliant date
// string: Safari and other strict engines return Invalid Date for it, so we
// normalize the space to "T" before parsing.
export function parseTimestamp(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const normalized = typeof value === "string" ? value.replace(" ", "T") : value;
  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

// Epoch millis for a timestamp, or 0 when missing/invalid. Use in sort
// comparators so undated rows sort to the bottom of a descending sort.
export function timeOf(value) {
  const d = parseTimestamp(value);
  return d ? d.getTime() : 0;
}

// Build a human-friendly reference id like "202605-0042" from a record's
// createdAt month (YYYYMM) and zero-padded numeric id. Mirrors the backend
// format: date('Ym') . '-' . str_pad(id, 4, '0', STR_PAD_LEFT).
export function formatRefId(item) {
  if (!item || item.id == null) return "";
  const padId = String(item.id).padStart(4, "0");
  const d = parseTimestamp(item.createdAt);
  if (!d) return padId;
  const ym = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`;
  return `${ym}-${padId}`;
}

// Render a date value as a short, readable string (e.g. "31 May 2026").
export function formatDate(value) {
  const d = parseTimestamp(value);
  if (!d) return "-";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
